export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14832.a8b641a1.jpg";